<template>
	<div class="big-screen">
		<header class="big-screen__top">
			<div class="nowtime">{{nowTime}}</div>
			<div class="title-box">
				<img src="../../assets/财金logo.png" style="width:30px;" />
				<span style="text-align: center;margin-left: 5px;font-size: 2.7vh;">枣庄市资产管理有限公司·智慧大屏</span>
			</div>
			<el-tooltip class="item" effect="light" content="刷新" placement="bottom">
				<el-button class="refreash" circle size="small" plain icon="el-icon-refresh"
					@click="refresh()"></el-button>
			</el-tooltip>
		</header>

		<div class="big-screen__box">
			<BSLeft v-if="token" @chart-click="handleChartClick" @data-click="handleDataClick"
				@list-click="handleListClick" />
			<BSCenter v-if="token" @chart-click="handleChartClick" @data-click="handleDataClick" />
			<BSRight v-if="token" @chart-click="handleChartClick" @data-click="handleDataClick" />
		</div>
		<!-- <AnotherComponent ref="anotherComponentRef" /> -->


		<!-- 弹窗列表 -->
		<div class="tablelist" :class="{'tablelist--equity': chartData && chartData.componentName === 'EquityAssetChart'}" v-if="dialogVisibleTaleList && chartData">
			<div class="title">
				<div class="dian"></div>
				<div class="title-title" v-if="dialogType == 'table'">{{chartData.data.name}}
					<!-- :{{chartData.data.value}} -->
					<!-- <span style="font-size:12px" v-if="chartData.data.danwei">{{chartData.data.danwei}}</span> -->
				</div>
				<div class="title-title" v-else-if="dialogType == 'data'">{{chartData.title}}
				</div>
				<el-button @click="dialogVisibleTaleList = false;IsTaleDetailList = false" type="text"
					icon="el-icon-circle-close" />
			</div>
			<!-- 股权资产持有数 - 自有股权 + 代管股权 左右双列 -->
			<template v-if="chartData && chartData.componentName === 'EquityAssetChart'">
				<div class="equity-panels">
					<div class="equity-panel">
						<div class="equity-panel-title">自有股权</div>
						<el-table :data="tableData" class="tabletable" stripe :border="false"
							style="width: 100%;background-color: #071a52;" header-row-class-name="custom-header"
							@row-click="handleclicktablerow" height="220">
							<el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
							<el-table-column prop="assetName" label="资产名称" show-overflow-tooltip></el-table-column>
						</el-table>
					</div>
					<div class="equity-panel">
						<div class="equity-panel-title">代管股权</div>
						<el-table :data="daiguanEquityList" class="tabletable" stripe :border="false"
							style="width: 100%;background-color: #071a52;" header-row-class-name="custom-header"
							height="220">
							<el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
							<el-table-column prop="assetName" label="资产名称" show-overflow-tooltip></el-table-column>
						</el-table>
					</div>
				</div>
			</template>

			<!-- 其他弹框 - 原有单列布局 -->
			<el-table v-else :data="tableData" class="tabletable" stripe :border="false"
				style="width: 100%;background-color: #071a52;" header-row-class-name="custom-header"
				@row-click="handleclicktablerow" height="240">
				<el-table-column type="index" width="50" label="序号" align="center">
				</el-table-column>
				<!-- 三类资产合并时显示资产类型列 -->
				<el-table-column
					v-if="chartData && chartData.componentName === 'AllAssetsChart'"
					prop="assetType" label="资产类型" width="90" align="center">
					<template slot-scope="scope">
						<el-tag size="mini"
							:type="scope.row.assetType === '存量资产' ? 'success' : scope.row.assetType === '股权资产' ? 'warning' : 'danger'">
							{{scope.row.assetType}}
						</el-tag>
					</template>
				</el-table-column>
				<!-- 不良资产使用"责务详情"列，其他资产使用"资产编号"列 -->
				<el-table-column
					v-if="chartData && chartData.componentName === 'ZCbuliangzichanbaoxingzhizhanbi'"
					prop="assetName" label="资产名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column
					v-else-if="chartData && chartData.componentName === 'ZCguquanzichangufen'"
					prop="shareholdersName" label="股东名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column
					v-else
					prop="assetName" label="资产名称" show-overflow-tooltip>
				</el-table-column>
			</el-table>
		</div>


		<!-- 弹窗详情 - 靠右显示 (handleDataClick) -->
		<div class="tablelist2 right-dialog" v-if="IsTaleDetailList && TaleDetailData && dialogType === 'table'">
			<div class="title"><span v-if="TaleDetailData.assetType == '存量资产' && videolist.length > 0">资产视频</span> <el-button
					@click="closeDialog" type="text" icon="el-icon-circle-close" /></div>
			<div class="video-container" v-if="TaleDetailData.assetType == '存量资产' && videolist.length > 0">
				<div
					class="asset-video"
					v-for="(item, index) in videolist"
					:key="item.uid"
					:class="{'single-video': videolist.length === 1, 'multiple-videos': videolist.length > 1}"
				>
					<video
						ref="thumbVideo"
						:src="item.url"
						muted
						autoplay
						loop
						playsinline
						class="vidpc"
						preload="metadata"
					/>
					<div class="video-overlay" @click="openVideoPlayer(item)">
						<div class="play-icon">
							<i class="el-icon-video-play"></i>
						</div>
						<div class="overlay-text">点击查看</div>
					</div>
				</div>
			</div>
			<div class="title">
				资产信息
				<el-tag size="small" class="tag-pri">{{TaleDetailData.assetCode}}</el-tag>
				<el-tag size="small" class="tag-warming">{{TaleDetailData.assetType}}</el-tag>
			</div>
			<div class="msg" v-if="TaleDetailData.assetType == '存量资产'">
				<div>资产名称：{{TaleDetailData.assetName}}</div>
				<div>资产价值(元)：{{TaleDetailData.amount}}</div>
				<div>资产状态：{{TaleDetailData.status}}</div>
				<div>资产负责人：{{TaleDetailData.manager}}</div>
				<div>创建时间：{{TaleDetailData.createTime}}</div>
				<div>资产位置：{{TaleDetailData.address}}</div>
				<div>备注：{{TaleDetailData.description}}</div>
			</div>
			<div class="msg" v-if="TaleDetailData.assetType == '不良资产'">
				<div>资产包名称：{{TaleDetailData.assetName}}</div>
				<div>资产价值(元)：{{TaleDetailData.amount}}</div>
				<div>资产负责人：{{TaleDetailData.manager}}</div>
				<div>创建时间：{{TaleDetailData.createTime}}</div>
				<div>资产详细信息：{{TaleDetailData.assetDetailName}}</div>
				<div>备注：{{TaleDetailData.description}}</div>
			</div>
			<div class="msg" v-if="TaleDetailData.assetType == '股权资产'">
				<div>资产名称：{{TaleDetailData.assetName}}</div>
				<div>出资金额(元)：{{TaleDetailData.amount}}</div>
				<div>持股金额(万元)：{{TaleDetailData.holdingAmount}}</div>
				<div>持股比例(%)：{{TaleDetailData.shareRatio}}%</div>
				<div>法定代表人：{{TaleDetailData.fadingdaibiao || '--'}}</div>
				<div>资产负责人：{{TaleDetailData.manager}}</div>
				<div>创建时间：{{TaleDetailData.createTime}}</div>
				<div>相关董事：{{TaleDetailData.dongshi}}</div>
				<div>经理层：{{TaleDetailData.jingli}}</div>
				<div>备注：{{TaleDetailData.description}}</div>
			</div>
		</div>
		<!-- 弹窗详情 - 居中显示 (handleListClick) -->
		<div class="tablelist2 center-dialog" v-if="IsTaleDetailList && TaleDetailData && dialogType === 'list'">
			<div class="title">
				<span v-if="TaleDetailData.assetType == '存量资产' && videolist.length > 0">资产视频</span>
				<el-button @click="closeDialog" type="text" icon="el-icon-circle-close" />
			</div>
			<div class="video-container" v-if="TaleDetailData.assetType == '存量资产' && videolist.length > 0">
				<div
					class="asset-video"
					v-for="(item, index) in videolist"
					:key="item.uid"
					:class="{'single-video': videolist.length === 1, 'multiple-videos': videolist.length > 1}"
				>
					<video
						ref="thumbVideo"
						:src="item.url"
						muted
						autoplay
						loop
						playsinline
						class="vidpc"
						preload="metadata"
					/>
					<div class="video-overlay" @click="openVideoPlayer(item)">
						<div class="play-icon">
							<i class="el-icon-video-play"></i>
						</div>
						<div class="overlay-text">点击查看</div>
					</div>
				</div>
			</div>
			<div class="title">
				资产信息
				<el-tag size="small" class="tag-pri">{{TaleDetailData.assetCode}}</el-tag>
				<el-tag size="small" class="tag-warming">{{TaleDetailData.assetType}}</el-tag>
			</div>
			<div class="msg2" v-if="TaleDetailData.assetType == '存量资产'">
				<div>资产名称：{{TaleDetailData.assetName}}</div>
				<div>资产价值(元)：{{TaleDetailData.amount}}</div>
				<div>资产状态：{{TaleDetailData.status}}</div>
				<div>资产负责人：{{TaleDetailData.manager}}</div>
				<div>创建时间：{{TaleDetailData.createTime}}</div>
				<div>资产位置：{{TaleDetailData.address}}</div>
				<div>备注：{{TaleDetailData.description}}</div>
			</div>
			<div class="msg2" v-if="TaleDetailData.assetType == '不良资产'">
				<div>资产包名称：{{TaleDetailData.assetName}}</div>
				<div>资产价值(元)：{{TaleDetailData.amount}}</div>
				<div>资产负责人：{{TaleDetailData.manager}}</div>
				<div>创建时间：{{TaleDetailData.createTime}}</div>
				<div>资产详细信息：{{TaleDetailData.assetDetailName}}</div>
				<div>备注：{{TaleDetailData.description}}</div>
			</div>
			<div class="msg2" v-if="TaleDetailData.assetType == '股权资产'">
				<div>资产名称：{{TaleDetailData.assetName}}</div>
				<div>出资金额(元)：{{TaleDetailData.amount}}</div>
				<div>持股金额(万元)：{{TaleDetailData.holdingAmount}}</div>
				<div>持股比例(%)：{{TaleDetailData.shareRatio}}%</div>
				<div>法定代表人：{{TaleDetailData.fadingdaibiao || '--'}}</div>
				<div>资产负责人：{{TaleDetailData.manager}}</div>
				<div>创建时间：{{TaleDetailData.createTime}}</div>
				<div>相关董事：{{TaleDetailData.dongshi}}</div>
				<div>经理层：{{TaleDetailData.jingli}}</div>
				<div>备注：{{TaleDetailData.description}}</div>
			</div>
		</div>

		<!-- 部分出租 - 地块+位置明细弹框 -->
		<div class="tablelist partial-rental-dialog" v-if="partialRentalDialog">
			<div class="title">
				<div class="dian"></div>
				<div class="title-title">{{ partialRentalDialogTitle }}</div>
				<el-button @click="partialRentalDialog = false" type="text" icon="el-icon-circle-close" />
			</div>
			<el-table
				:data="partialRentalFlatData"
				class="tabletable"
				:border="true"
				style="width:100%;background-color:#071a52;"
				header-row-class-name="custom-header"
				:span-method="partialRentalSpanMethod"
				height="370">
				<el-table-column prop="assetName" label="地块" width="180" show-overflow-tooltip />
				<el-table-column prop="locationName" label="位置" show-overflow-tooltip>
					<template slot-scope="scope">
						<span :class="scope.row.status === '待出租' ? 'loc-waiting' : 'loc-rented'">{{ scope.row.locationName }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="70" align="center">
					<template slot-scope="scope">
						<el-tag size="mini" :type="scope.row.status === '已出租' ? 'success' : 'warning'">{{ scope.row.status }}</el-tag>
					</template>
				</el-table-column>
			</el-table>
		</div>

	</div>
</template>

<script>
	import apis from "@/http/apis";
	import { dedupeEquityByAssetName, getEquityHoldPanels, DAIGUAN_EQUITY_LIST } from './charts/equity-detail-filter';
	import Cookies from 'js-cookie';
	import axios from "axios";
	import ScreenButton from "../../components/screent_button.vue";
	import BSLeft from "./screent_left.vue";
	import BSCenter from "./screent_center.vue";
	import BSRight from "./screent_right.vue";
	// import AnotherComponent from "./screent_center.vue";

	export default {
		components: {
			ScreenButton,
			BSLeft,
			BSCenter,
			BSRight,
			apis,
			Cookies,
			// AnotherComponent
		},
		data() {
			return {
				token: true, // 暂不鉴权，直接设为true
				currentTime: new Date(),
				timer: "", //定义一个定时器
				nowTime: "",
				// 中文→ NonResidentialType 编码映射（存量资产分类，共10种）
				MAPPING_ASSET_CATEGORY: {
					'门市':       '1319',
					'电影院':     '1320',
					'土地':       '1001420',
					'办公室':     '1001421',
					'住宅':       '1001422',
					'土地及附着物': '1001423',
					'房产':       '1001424',
					'酒店':       '1001425',
					'公寓':       '1001426',
					'地上附着物':  '1001427',
				},
				MAPPING_RENTAL_STATUS: { '待出租': 'WAITING', '部分出租': 'PARTIAL', '已出租': 'FULL', '其他': 'OTHER' },
				MAPPING_ASSET_NATURE: { '自有资产': 1312, '代管资产': 1313 },
				MAPPING_PACK_TYPE: { '购入资产': 'PURCHASE', '代理资产': 'AGENT', '自有资产': 'OWN', '其他': 'OTHER' },
				// 弹窗相关数据
				dialogVisibleTaleList: true,
				chartData: null,
				// 代管股权 - 暂无接口，先写死
				daiguanEquityList: [...DAIGUAN_EQUITY_LIST],
				IsTaleDetailList: true,
				TaleDetailData: null,
				dialogType: '', // 弹窗类型: 'data' 或 'list'或'table'
				// dialogTitle: "图表详情",
				// 示例数据 - 表格数据
				tableData: [{
						id: 1,
						assetCode: 'ZCGL202501020001',
						assetName: '枣庄市枣庄电影院',
						assetType: '存量资产',
						manager: '李峰',
						createTime: '2025-12-23 21:07:50',
						status: '待出租',
						amount: '1,200,000.00',
						address: '山东省枣庄市市中区中心街街道胜利东路142号中兴公馆',
						description: '备注'
					},
					{
						id: 2,
						assetCode: 'BLZC202501020001',
						assetName: '北马路：北马路电脑耗材、北马路足疗店（三间门市）',
						assetType: '存量资产',
						manager: '李峰',
						createTime: '2025-11-15 14:30:25',
						status: '处置中',
						amount: '800,000.00',
						address: '枣庄市北马路足疗店',
						description: '暂无备注'
					},
					{
						id: 3,
						assetCode: 'BLZC202501020001',
						assetName: '枣庄外运',
						assetType: '存量资产',
						manager: '李峰',
						createTime: '2025-11-15 14:30:25',
						status: '处置中',
						amount: '800,000.00',
						address: '枣庄市振兴南路西',
						description: '暂无备注'
					}
				],
				//视频内容
				videolist: [],
				loading: true,
				// 部分出租明细弹框
				partialRentalDialog: false,
				partialRentalDialogTitle: '出租明细',
				partialRentalFlatData: [], // 扁平化后的行数据，供 el-table 渲染
			}
		},

		created() {
			// this.gettoken(); // 暂不鉴权，已注释
			// this.getdate();
			this.getNowTime();
			setInterval(() => {
				this.currentTime = new Date();
			}, 10000);
			// setInterval(() => { // 暂不鉴权，已注释
			// 	this.gettoken()
			// }, 600000);
		},
		beforeDestroy() {
			this.videolist = [];
		},
		methods: {
			// 打开出租明细弹框（待出租/部分出租/已出租 共用同一弹框）
			// rentalStatus: WAITING | PARTIAL | FULL
			openPartialRentalDialog(rentalStatus) {
				const titleMap = { WAITING: '待出租明细', PARTIAL: '部分出租明细', FULL: '已出租明细', ALL: '存量资产明细' };
				this.partialRentalDialogTitle = titleMap[rentalStatus] || '出租明细';
				this.dialogVisibleTaleList = false;
				this.IsTaleDetailList = false;
				apis.rentalDetail(rentalStatus).then((res) => {
					const groups = (res && res.data && res.data.list) ? res.data.list : [];
					// 将嵌套结构扁平化，计算每个地块行的 rowspan
					const flat = [];
					groups.forEach(group => {
						const locs = group.locations && group.locations.length ? group.locations : [{ locationName: '暂无位置数据', status: '' }];
						locs.forEach((loc, idx) => {
							flat.push({
								assetName: group.assetName,
								locationName: loc.locationName,
								status: loc.status,
								assetRowspan: idx === 0 ? locs.length : 0,
							});
						});
					});
					this.partialRentalFlatData = flat;
					this.partialRentalDialog = true;
				}).catch(() => {
					this.partialRentalFlatData = [];
					this.partialRentalDialog = true;
				});
			},
			// el-table span-method：合并「地块」列相同资产的单元格
			partialRentalSpanMethod({ rowIndex, columnIndex }) {
				if (columnIndex === 0) { // 地块列
					const rowspan = this.partialRentalFlatData[rowIndex].assetRowspan;
					return rowspan > 0 ? { rowspan, colspan: 1 } : { rowspan: 0, colspan: 0 };
				}
			},
			handleclicktablerow(row) {
				// 股东占股列表行不打开详情面板
				if (this.chartData && this.chartData.componentName === 'ZCguquanzichangufen') return;
				this.TaleDetailData = row;
				console.log(this.TaleDetailData, 'this.TaleDetailData')
				this.IsTaleDetailList = true
				this.$bus.$emit('close-map-marker'); // 关闭地图标点弹框，避免两个面板同时显示造成混乱
				this.getJjVideo();
			},

			// 处理图表点击事件
			handleChartClick(data) {
				this.dialogVisibleTaleList = false;
				this.IsTaleDetailList = false;
				this.partialRentalDialog = false;
				this.dialogType = 'table';
				console.log('收到图表点击事件:', data);
				this.chartData = data;

				// 股权资产持有图表：直接展示点击公司的股权资产详情，跳过列表
				if (data.componentName === 'ZCguquanzichanchiyougufen') {
					const companyName = data.data && data.data.name;
					apis.equityAssetList(companyName)
						.then((res) => {
							const list = (res && res.data && res.data.list) ? res.data.list : [];
							// 优先匹配 assetName 与公司名一致的条目，否则取第一条
							const matched = list.find(item => item.assetName === companyName) || list[0] || null;
							if (matched) {
								// 将图表中的持股金额一并挂载，供详情面板展示
								this.TaleDetailData = Object.assign({}, matched, {
									holdingAmount: (data.data && data.data.value != null) ? data.data.value : '--'
								});
								this.IsTaleDetailList = true;
							}
						})
						.catch(() => {
							// 请求失败不做任何弹窗
						});
				// 股东占股比例柱状图：展示全部股东占股列表
				} else if (data.componentName === 'ZCguquanzichangufen') {
					apis.equityShareholderRatio()
						.then((res) => {
							const list = (res && res.data && res.data.list) ? res.data.list : [];
							this.tableData = list.map((item, idx) => ({
								shareholdersName: item.shareholdersName || '--',
								equityRatio: item.equityRatio != null ? Number(item.equityRatio).toFixed(2) + '%' : '--',
							}));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
				// 资产出租率饼图：按出租状态拉取存量资产列表并展示
				} else if (data.componentName === 'AssetRentalRateChart') {
					const clickedName = data.data && data.data.name;
					const rentalStatusEn = this.MAPPING_RENTAL_STATUS[clickedName] || clickedName;
					if (clickedName === '待出租' || clickedName === '部分出租' || clickedName === '已出租') {
						// 三种出租状态均展示地块+位置嵌套表格
						this.openPartialRentalDialog(rentalStatusEn);
					} else {
						apis.stockAssetListByRentalStatus(rentalStatusEn)
							.then((res) => {
								const rawList = (res && res.data && res.data.list) ? res.data.list : [];
								this.tableData = rawList.map(item => Object.assign({ assetType: '存量资产' }, item));
								this.dialogVisibleTaleList = true;
							})
							.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
					}
				// 存量资产分类图表：按 NonResidentialType 编码拉取存量资产列表并展示
				} else if (data.componentName === 'StockAssetCategoryChart') {
					const clickedName = data.data && data.data.name;
					const typeCode = this.MAPPING_ASSET_CATEGORY[clickedName] || clickedName;
					console.log('[debug] 存量资产分类图表点击 → name=', clickedName, ' typeCode=', typeCode);
					apis.stockAssetListByNonResidentialType(typeCode)
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							console.log('[debug] 存量资产分类列表返回条数=', rawList.length, ' typeCode=', typeCode);
							this.tableData = rawList.map(item => Object.assign({ assetType: '存量资产' }, item));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => {
							this.tableData = [];
							this.dialogVisibleTaleList = true;
						});
				// 存量资产性质占比（柱图/饼图）：按性质名称拉取存量资产列表并展示
				} else if (data.componentName === 'StockAssetNatureBarChart' || data.componentName === 'StockAssetNaturePieChart') {
					const assetNature = this.MAPPING_ASSET_NATURE[data.data && data.data.name] || (data.data && data.data.name);
					apis.stockAssetListByAssetNature(assetNature)
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							this.tableData = rawList.map(item => Object.assign({ assetType: '存量资产' }, item));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
				// 不良资产包类别占比柱状图：按类别名称拉取列表
				} else if (data.componentName === 'ZCbuliangzichanbaoxingzhizhanbi') {
					const seriesName = data.seriesName;
					const caseStatusMap = { '追偿中': 0, '已结案': 1 };
					if (seriesName in caseStatusMap) {
						// 点击堆叠分段（追偿中/已结案）→ 按案件状态筛选
						apis.nonPerformingAssetListByCaseStatus(caseStatusMap[seriesName])
							.then((res) => {
								const rawList = (res && res.data && res.data.list) ? res.data.list : [];
								this.tableData = rawList.map(item => Object.assign({ assetType: '不良资产' }, item));
								this.dialogVisibleTaleList = true;
							})
							.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
					} else {
						// 点击 y 轴标签或整体 → 按资产包分类筛选
						const categoryName = (data.data && typeof data.data === 'object' && data.data.name)
							? data.data.name
							: '信通资产';
						apis.nonPerformingAssetListByCategory(categoryName)
							.then((res) => {
								const rawList = (res && res.data && res.data.list) ? res.data.list : [];
								this.tableData = rawList.map(item => Object.assign({ assetType: '不良资产' }, item));
								this.dialogVisibleTaleList = true;
							})
							.catch(() => {
								this.tableData = [];
								this.dialogVisibleTaleList = true;
							});
					}
				// 不良资产案件状态饼图（追偿中/已结案）：按 CaseStatus 拉取列表
				} else if (data.componentName === 'RingChart') {
					const clickedName = data.data && data.data.name;
					// 名称映射到状态码
					const caseStatus = clickedName === '追偿中' ? 0 : clickedName === '已结案' ? 1 : null;
					if (caseStatus === null) {
						this.tableData = [];
						this.dialogVisibleTaleList = true;
						return;
					}
					apis.nonPerformingAssetListByCaseStatus(caseStatus)
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							this.tableData = rawList.map(item => Object.assign({ assetType: '不良资产' }, item));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => {
							this.tableData = [];
							this.dialogVisibleTaleList = true;
						});
				} else {
					this.dialogVisibleTaleList = true;
				}
			},
				handleRentalStatusClick(rentalStatus) {
				this.dialogVisibleTaleList = false;
				this.IsTaleDetailList = false;
				this.dialogType = 'table';
				this.chartData = { data: { name: rentalStatus }, componentName: 'AssetRentalRateChart' };
				const rentalStatusEn = this.MAPPING_RENTAL_STATUS[rentalStatus] || rentalStatus;
				// 三种出租状态均展示地块+位置嵌套表格
				if (rentalStatus === '待出租' || rentalStatus === '部分出租' || rentalStatus === '已出租') {
					this.openPartialRentalDialog(rentalStatusEn);
					return;
				}
				apis.stockAssetListByRentalStatus(rentalStatusEn)
					.then((res) => {
						const rawList = (res && res.data && res.data.list) ? res.data.list : [];
						this.tableData = rawList.map(item => Object.assign({ assetType: '存量资产' }, item));
						this.dialogVisibleTaleList = true;
					})
					.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
				},
				handleDataClick(data) {
				if (this.dialogVisibleTaleList) {
					this.dialogVisibleTaleList = false;
				}
				this.IsTaleDetailList = false;
				this.partialRentalDialog = false;
				const title = data.title;

				// 出租状态卡片（右栏 待出租/部分出租/已出租）按状态拉列表
				const rentalStatusList = ['待出租', '部分出租', '已出租', '其他'];
				if (rentalStatusList.includes(title)) {
					this.handleRentalStatusClick(title);
					return;
				}

				// 存量资产分类卡片（左栏，按 NonResidentialType 分类）按编码拉列表
				const nonResidentialTypeCode = this.MAPPING_ASSET_CATEGORY[title];
				if (nonResidentialTypeCode) {
					this.dialogType = 'table';
					this.chartData = { data: { name: title }, componentName: 'StockAssetCategoryChart' };
					console.log('[debug] 存量资产分类卡片点击 → title=', title, ' typeCode=', nonResidentialTypeCode);
					apis.stockAssetListByNonResidentialType(nonResidentialTypeCode)
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							console.log('[debug] 分类列表返回条数=', rawList.length, ' typeCode=', nonResidentialTypeCode);
							this.tableData = rawList.map(item => Object.assign({ assetType: '存量资产' }, item));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
					return;
				}

				// 存量资产总数 → 弹出地块+位置嵌套弹框，展示所有存量资产
				if (title === '存量资产总数') {
				this.openPartialRentalDialog('ALL');
				return;

				// 股权资产持有数 → 拉取全部股权资产
				} else if (title === '股权资产持有数') {
					this.dialogType = 'table';
					this.chartData = { data: { name: title }, componentName: 'EquityAssetChart' };
					apis.equityAssetList()
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							const panels = getEquityHoldPanels(rawList);
							this.tableData = panels.companyList;
							this.daiguanEquityList = panels.daiguanList;
							this.dialogVisibleTaleList = true;
						})
						.catch(() => {
							this.tableData = [];
							this.daiguanEquityList = [...DAIGUAN_EQUITY_LIST];
							this.dialogVisibleTaleList = true;
						});

				// 不良资产总户数 → 拉取全部不良资产
				} else if (title === '不良资产总户数') {
					this.dialogType = 'table';
					this.chartData = { data: { name: title }, componentName: 'ZCbuliangzichanbaoxingzhizhanbi' };
					apis.nonPerformingAssetList()
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							this.tableData = rawList.map(item => Object.assign({ assetType: '不良资产' }, item));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });

				// 资产总数 → 并发拉取存量+股权+不良三类资产合并展示
				} else if (title === '资产总数') {
					this.dialogType = 'table';
					this.chartData = { data: { name: title }, componentName: 'AllAssetsChart' };
					Promise.all([
						apis.stockAssetList().catch(() => ({ data: { list: [] } })),
						apis.equityAssetList().catch(() => ({ data: { list: [] } })),
						apis.nonPerformingAssetList().catch(() => ({ data: { list: [] } })),
					]).then(([stockRes, equityRes, badRes]) => {
						const stockList  = (stockRes  && stockRes.data  && stockRes.data.list)  ? stockRes.data.list  : [];
						const equityList = dedupeEquityByAssetName(
							(equityRes && equityRes.data && equityRes.data.list) ? equityRes.data.list : []
						);
						const badList    = (badRes    && badRes.data    && badRes.data.list)    ? badRes.data.list    : [];
						this.tableData = [
							...stockList.map(item  => Object.assign({ assetType: '存量资产' }, item)),
							...equityList.map(item => Object.assign({ assetType: '股权资产' }, item)),
							...badList.map(item    => Object.assign({ assetType: '不良资产' }, item)),
						];
						this.dialogVisibleTaleList = true;
					});
				// 资产总规模 → 并发拉取三类资产合并展示
				} else if (title === '资产总规模') {
					this.dialogType = 'table';
					this.chartData = { data: { name: title }, componentName: 'AllAssetsChart' };
					Promise.all([
						apis.stockAssetList().catch(() => ({ data: { list: [] } })),
						apis.equityAssetList().catch(() => ({ data: { list: [] } })),
						apis.nonPerformingAssetList().catch(() => ({ data: { list: [] } })),
					]).then(([stockRes, equityRes, badRes]) => {
						const stockList  = (stockRes  && stockRes.data  && stockRes.data.list)  ? stockRes.data.list  : [];
						const equityList = dedupeEquityByAssetName(
							(equityRes && equityRes.data && equityRes.data.list) ? equityRes.data.list : []
						);
						const badList    = (badRes    && badRes.data    && badRes.data.list)    ? badRes.data.list    : [];
						this.tableData = [
							...stockList.map(item  => Object.assign({ assetType: '存量资产' }, item)),
							...equityList.map(item => Object.assign({ assetType: '股权资产' }, item)),
							...badList.map(item    => Object.assign({ assetType: '不良资产' }, item)),
						];
						this.dialogVisibleTaleList = true;
					});
		// 股东占股比例TOP3卡片：展示全部股东占股列表
				} else if (title && title.startsWith('TOP')) {
					this.dialogType = 'table';
					this.chartData = { data: { name: '股东占股列表' }, componentName: 'ZCguquanzichangufen' };
					apis.equityShareholderRatio()
						.then((res) => {
							const list = (res && res.data && res.data.list) ? res.data.list : [];
							this.tableData = list.map(item => ({
								shareholdersName: item.shareholdersName || '--',
								equityRatio: item.equityRatio != null ? Number(item.equityRatio).toFixed(2) + '%' : '--',
							}));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
		// 其他兜底（营收总额等）→ 拉取全部存量资产
				} else {
					this.dialogType = 'table';
					this.chartData = { data: { name: title }, componentName: 'StockAssetCategoryChart' };
					apis.stockAssetList()
						.then((res) => {
							const rawList = (res && res.data && res.data.list) ? res.data.list : [];
							this.tableData = rawList.map(item => Object.assign({ assetType: '存量资产' }, item));
							this.dialogVisibleTaleList = true;
						})
						.catch(() => { this.tableData = []; this.dialogVisibleTaleList = true; });
				}
			},
			handleListClick(data) {
				if (this.dialogVisibleTaleList) {
					this.dialogVisibleTaleList = false; //之前的列表关闭
				}
				this.dialogType = 'list'; // 标记为 list 类型
				this.TaleDetailData = data;
				console.log('收到列表点击事件:', data);
				this.IsTaleDetailList = true
				this.getJjVideo();
			},
			closeDialog() {
				this.pauseThumbVideos(true);
				this.videolist = [];
				this.IsTaleDetailList = false;
				this.dialogType = ''; // 重置弹窗类型
			},


			refresh() {
				location.reload()
			},
			getNowTime() {
				this.timer = setInterval(() => {
					let timeDate = new Date();
					let year = timeDate.getFullYear();
					let mounth = timeDate.getMonth() + 1;
					let day = timeDate.getDate();
					let hours = timeDate.getHours();
					hours = hours >= 10 ? hours : "0" + hours;
					let minutes = timeDate.getMinutes();
					minutes = minutes >= 10 ? minutes : "0" + minutes;
					let seconds = timeDate.getSeconds();
					seconds = seconds >= 10 ? seconds : "0" + seconds;
					let week = timeDate.getDay();
					let weekArr = [
						"星期日",
						"星期一",
						"星期二",
						"星期三",
						"星期四",
						"星期五",
						"星期六",
					];

					this.nowTime = `${year}/${mounth}/${day}` + ` ${hours}:${minutes}:${seconds}` +
						` ${weekArr[week]}`
				}, 1000);
			},


			gettoken() {
				// 暂不鉴权，以下逻辑已注释
				// apis.gettoken()
				// 	.then((res) => {
				// 		Cookies.set('token', res.token)
				// 		let timestamp = (new Date()).valueOf();
				// 		let expireDatetimes = timestamp + (res.expire * 1000);
				// 		Cookies.set('expireDatetimes', expireDatetimes)
				// 		axios.interceptors.request.use(config => {
				// 				config.headers["Content-Type"] = "application/json;charset=UTF-8"
				// 				if (Cookies.get("token")) {
				// 					config.headers['token'] = null
				// 					config.headers['token'] = `${Cookies.get("token")}`;
				// 				}
				// 				return config
				// 			},
				// 			error => {
				// 				return Promise.reject(error.response)
				// 			})
				// 		this.token = true
				// 	})
			},
			getdate() {
				this.timer = setInterval(() => {
					setTimeout(() => {
						this.gettoken()
					}, 0)
				}, 300000);
			},

			//以下是播放视频内容
			// 支持嵌套对象访问的方法
			getNestedValue(obj, path) {
				if (!obj || !path) return '';

				try {
					return path.split('.').reduce((current, key) => {
						return current && current[key] !== undefined ? current[key] : '';
					}, obj);
				} catch (error) {
					return '';
				}
			},

			getJjVideo() {
				const videoUrls = this.TaleDetailData && this.TaleDetailData.videoUrls;
				if (videoUrls && videoUrls.length > 0) {
					this.videolist = videoUrls.map((url, idx) => ({
						name: '资产视频' + (idx + 1),
						url,
						uid: `${Date.now()}_${idx}`,
					}));
				} else {
					this.videolist = [];
				}
				this.loading = false;
			},

			pauseThumbVideos(clearSrc = false) {
				const refs = this.$refs.thumbVideo;
				if (!refs) return;
				(Array.isArray(refs) ? refs : [refs]).forEach((video) => {
					if (!video) return;
					video.pause();
					if (clearSrc) {
						video.removeAttribute('src');
						video.load();
					}
				});
			},

			openVideoInNewTab(url) {
				const link = document.createElement('a');
				link.href = url;
				link.target = '_blank';
				link.rel = 'noopener noreferrer';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},

			openVideoPlayer(item) {
				if (!item || !item.url) return;
				this.pauseThumbVideos(false);
				this.openVideoInNewTab(item.url);
			},


		},
	};
</script>

<style lang="scss" scoped>
	$fontsize: 13px;

	.big-screen {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;


		background-image: url("../../assets/bgimg2.png");
		background-size: 100% 100%;

		&::after {
			content: "";
			display: block;
			width: 100%;
			height: 17px;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			z-index: 1;
		}
	}

	.big-screen__top {
		width: 100%;
		height: 7vh;
	}

	.nowtime {
		width: auto;
		height: 30px;
		font-size: 1.7vh;
		text-align: center;
		position: fixed;
		color: #fff;
		top: 40px;
		left: 45px;
		font-weight: 600;
	}


	.title-box {
		height: 8vh;
		color: #fff;
		font-weight: 600;
		width: 100%;
		display: flex;
		justify-content: center;
		flex-wrap: nowrap;
		align-items: center;
		container-type: inline-size;
	}

	.big-screen__header {
		margin: 0 auto;
		display: flex;
		justify-content: center;
	}

	.big-screen_btn {
		margin: 10px 30px;
	}

	.big-screen__box {
		display: flex;
		padding-right: 20px;
		padding-left: 20px;
		margin-bottom: 0px;
		height: calc(100% - 7vh);
		box-sizing: border-box;
	}

	.refreash {
		position: fixed;
		top: 30px;
		right: 52px;
		z-index: 1;
		font-size: 18px;
		color: #ffffff;
		border-width: 2px;
		background-color: rgb(255 255 255 / 0%);


	}


	// 弹窗自定义样式


	.tablelist {
		width: 500px;
		height: auto;
		padding-bottom: 12px;
		position: fixed;
		top: 12vh;
		left: calc(50% - 250px);
		border-radius: 15px;
		background-color: rgb(0, 3, 81, 0.78);
		/* 底颜色 */
		border: 3px solid rgba(255, 255, 255, 0.8);
		/* 边框颜色 */
		z-index: 10000;
		overflow: hidden;
	}

	.tablelist--equity {
		width: 600px;
		height: 300px;
		left: calc(50% - 300px);
	}

	.equity-panels {
		display: flex;
		gap: 8px;
		padding: 0 8px 8px;
	}

	.equity-panel {
		flex: 1;
		overflow: hidden;
	}

	.equity-panel-title {
		color: #fcf883;
		font-size: 13px;
		font-weight: 600;
		text-align: center;
		padding: 4px 0;
		border-bottom: 1px solid rgba(255, 255, 255, 0.3);
		margin-bottom: 2px;
	}

	.dian {
		width: 18px;
		height: 18px;
		margin-right: 5px;
		border-radius: 20px;
		background-color: #fcf883;
	}

	.title {
		margin: 10px;
		color: #ffffff;
		font-size: 16px;
		font-weight: 600;
		gap: 5px;
		display: flex;
		align-items: center;
	}

	.title-title {
		width: 170px;
		color: #ffffff;
		font-size: 16px;
		font-weight: 600;
		white-space: nowrap;
		/* 强制不换行 */
		overflow: hidden;
		/* 隐藏溢出内容 */
		text-overflow: ellipsis;
		/* 用省略号代替溢出文本 */
	}

	.msg {
		margin: 10px;
		width: calc(100% - 20px);
		height: auto;
		color: #ffffffd6;
	}

	.msg2 {
		margin: 10px;
		width: calc(100% - 20px);
		height: auto;
		color: #ffffffd6;
		gap: 5px;
		display: flex;
		flex-direction: column;
	}

	::v-deep .el-icon-circle-close {
		position: absolute;
		right: 5px;
		top: 5px;
		font-size: 24px;
		color: #fff;
	}

	///以下是对弹窗中表格的自定义样式
	::v-deep .el-table tr {
		//行颜色
		color: #fff !important;
		background-color: #071a52ff !important;
	}

	::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
		background-color: #0d2569 !important;
	}

	::v-deep .el-table th.el-table__cell {
		//表头颜色
		color: #fff !important;
		background-color: #3c4a77 !important;
	}

	// 1. 表头
	::v-deep .el-table__header-wrapper .el-table__header th.el-table__cell {
		font-size: 13px;
		height: 20px !important; // 表头高度
		line-height: 20px !important;
	}

	// 2. 表格行
	::v-deep .el-table__body-wrapper .el-table__body tr td.el-table__cell {
		font-size: 12px;
		height: 20px !important; // 行高度
		line-height: 20px !important;
	}

	// 3. 斑马纹行的行
	::v-deep .el-table__body-wrapper .el-table__body tr.el-table__row--striped td.el-table__cell {
		font-size: 12px;
		height: 20px !important;
		line-height: 20px !important;
	}

	// 4. 单元格内边距
	::v-deep .el-table__cell {
		padding: 5px 0 !important; // 调整单元格上下内边距来控制行高
	}

	// 如果需要更细的控制，可以单独设置单元格内边距
	::v-deep .el-table.el-table__cell {
		padding: 8px 0 !important; // 调整单元格上下内边距来控制行高
	}


	// 只去掉横向边框，保留纵向边框
	::v-deep .el-table__cell {
		border-right: 1px solid rgba(255, 255, 255, 0.1) !important; // 保留纵向边框
		border-bottom: none !important; // 去掉横向边框
	}

	::v-deep .el-table__header-wrapper .el-table__header th.el-table__cell {
		border-right: 1px solid rgba(255, 255, 255, 0.1) !important; // 表头保留纵向边框
		border-bottom: none !important; // 去掉表头横向边框
	}

	::v-deep.el-table::before {
		height: 0px;
	}

	/* 部分出租弹框 - 居中、宽一些以展示地块+位置 */
	.partial-rental-dialog {
		width: 780px !important;
		height: 460px !important;
		top: 15vh !important;
		left: calc(50% - 390px) !important;
	}

	/* 已出租位置文字颜色 */
	.loc-rented {
		color: #07e1ff;
	}

	/* 待出租位置文字颜色（黄色高亮） */
	.loc-waiting {
		color: #fcf883;
		font-weight: 600;
	}

	/* handleDataClick 的样式 - 靠右显示 */
	.tablelist2.right-dialog {
		width: 620px;
		height: 720px;
		position: fixed;
		top: 8vh;
		right: calc(50% - 620px);
		border-radius: 15px;
		background-color: rgb(0, 3, 81, 0.78);
		border: 3px solid rgba(255, 255, 255, 0.8);
		z-index: 10000;
		overflow-y: auto;
	}

	/* handleListClick 的样式 - 居中显示 */
	.tablelist2.center-dialog {
		width: 35%;
		height: 67%;
		position: fixed;
		top: 10vh;
		left: 50%;
		transform: translateX(-50%);
		/* 使用 transform 实现精确居中 */

		border-radius: 15px;
		background-color: rgb(0, 3, 81, 0.78);
		border: 3px solid rgba(255, 255, 255, 0.8);
		z-index: 10000;
		overflow-y: auto;
	}




	/*滚动条样式*/
	.tablelist2::-webkit-scrollbar {
		width: 6px;
		height: 0px;
	}

	.tablelist2::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
		background: rgba(255, 255, 255, 0.2);
	}

	.tablelist2::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
		border-radius: 0;
		background: rgba(255, 255, 255, 0.1);
	}

	.tag-pri {
		background-color: #ecf5ff4f;
		border-color: #59acff;
		font-size: $fontsize;
		color: #fff;
	}

	.tag-warming {
		background-color: #fff6a1ff;
		border-color: #ebdf6a;
		font-size: $fontsize;
		color: #000;
	}



	/* 视频容器样式 */
	/* 视频容器样式 - 覆盖之前的定义 */
	.video-container {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		margin-bottom: 20px;
		width: 100%;
		height: auto;
		display: flex;
		justify-content: center;
	}

	.asset-video {
		position: relative;
		display: inline-block;
		cursor: pointer;
		overflow: hidden;
		border-radius: 8px;
		transition: all 0.3s ease;

		/* 默认值 - 适用于多个视频的情况 */
		width: 100px;
		height: 100px;

		.vidpc {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 8px;
			display: block;
			background: #000;
			pointer-events: none;
		}

		/* 遮罩层样式 */
		.video-overlay {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba(0, 0, 0, 0.4);
			opacity: 0;
			transition: opacity 0.3s ease;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			cursor: pointer;

			&:hover {
				opacity: 1;
				background: rgba(0, 0, 0, 0.6);
			}

			.play-icon {
				font-size: 48px;
				color: rgba(255, 255, 255, 0.9);
				margin-bottom: 10px;
				transition: transform 0.3s ease;

				i {
					filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
				}
			}

			.overlay-text {
				color: white;
				font-size: 14px;
				font-weight: 500;
				text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
				background: rgba(0, 0, 0, 0.5);
				padding: 4px 12px;
				border-radius: 16px;
				transition: all 0.3s ease;
			}
		}

		/* 鼠标悬停时显示遮罩 */
		&:hover .video-overlay {
			opacity: 1;

			.play-icon {
				transform: scale(1.1);
			}

			.overlay-text {
				background: rgba(0, 0, 0, 0.7);
			}
		}
	}

	// /* 使用JavaScript计算类名来控制比例 */
	// .asset-video.single-video {
	//   width: 160px;
	//   height: 90px;
	// }

	/* 或者使用更简单的方案 */
	.asset-video:only-child,
	.asset-video:first-child:last-child {
		//16:9的比例
		width: 96% !important;
		height: 54% !important;
	}

</style>